import { Directive, ElementRef, Input } from '@angular/core';
import { StandStatus } from '../../stands/symbols';
import { OrderStatus } from '../symbols';

@Directive({
  standalone: true,
  selector: '[statusStyle]'
})
export class StatusStyleDirective {

  constructor(private el: ElementRef) {
  }

  @Input() set status(value: OrderStatus | StandStatus) {

    this.el.nativeElement.style.padding = '10px';
    this.el.nativeElement.style.borderRadius = '20px';
    this.el.nativeElement.style.transition = 'all 0.3s ease-in-out';

    switch (value) {
      case OrderStatus.ACCEPTED:
        this.el.nativeElement.style.background = 'var(--accepted)';
        this.el.nativeElement.style.color = 'white';
        break;
      case OrderStatus.ISSUED:
        this.el.nativeElement.style.background = 'var(--issued)';
        this.el.nativeElement.style.color = 'var(--text-primary)';
        break;
      case OrderStatus.ISSUED_SELF:
        this.el.nativeElement.style.background = 'var(--issued-self)';
        this.el.nativeElement.style.color = 'var(--text-primary)';
        break;
      case OrderStatus.NOT_CONFIRMED:
        this.el.nativeElement.style.background = 'var(--not-confirmed)';
        break;
      case OrderStatus.DONE:
        break;
      case OrderStatus.CANCELLED:
        this.el.nativeElement.style.background = 'var(--cancelled)';
        this.el.nativeElement.style.color = 'var(--text-primary)';
        break;
      case StandStatus.INFORMED:
        this.el.nativeElement.style.background = 'var(--informed)';
        this.el.nativeElement.style.color = 'var(--text-primary)';
        break;
      default:
        this.el.nativeElement.style.background = 'var(--in-progress)';
        this.el.nativeElement.style.color = 'var(--text-primary)';
        break;
    }
  }


}
